import { useState } from "react"
import styles from "../styles/widget.module.css"

interface Props {
  onSubmit: (email: string) => void
}

export function EmailCaptureForm({ onSubmit }: Props) {
  const [email, setEmail] = useState("")
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        if (/.+@.+\..+/.test(email)) onSubmit(email)
      }}
      className={styles["rc-email-form"]}
    >
      <input
        type="email"
        placeholder="your@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={styles["rc-email-input"]}
        autoComplete="email"
      />
      <button type="submit" className={styles["rc-email-submit"]}>
        Send
      </button>
    </form>
  )
}
